var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1152 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745148 22.6384 0.745148 50.2484C0.745148 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74515 74.5084 6.74515 50.2484C6.74515 42.7784 8.61515 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0351 56.7384L78.7151 30.5484C79.1751 30.2284 79.4752 29.6984 79.4752 29.0984C79.4752 28.1284 78.6852 27.3384 77.7151 27.3384C76.9951 27.3384 76.3851 27.7684 76.1051 28.3784L56.0151 27.3684C56.1951 27.9184 56.2951 28.4984 56.2951 29.0984C56.2951 29.6984 56.1951 30.2884 56.0151 30.8284L76.1051 29.8184C76.2351 30.1084 76.4452 30.3684 76.7151 30.5484L66.3951 56.7384C66.3752 56.7884 66.3652 56.8284 66.3652 56.8884C66.3652 63.1484 71.4551 68.2384 77.7151 68.2384C83.9752 68.2384 89.0651 63.1484 89.0651 56.8884C89.0651 56.8384 89.0551 56.7884 89.0351 56.7384ZM78.1152 56.4884V31.1884L88.0851 56.4884H78.1152ZM77.3151 56.4884H67.3451L77.3151 31.1884V56.4884Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4851 23.8284L52.2051 17.8784C52.1651 17.0984 51.5251 16.4884 50.7451 16.4884C49.9651 16.4884 49.3251 17.0984 49.2851 17.8784L49.0051 23.8284C49.5551 23.6484 50.1351 23.5484 50.7451 23.5484C51.3551 23.5484 51.9352 23.6484 52.4851 23.8284Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9651 34.1684C52.2851 34.4684 51.5351 34.6284 50.7451 34.6284C49.9551 34.6284 49.2051 34.4584 48.5251 34.1684L46.7551 71.9684H54.7451L52.9751 34.1684H52.9651Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2951 76.6584H61.2051C61.2051 74.8084 59.7051 73.3084 57.8551 73.3084H43.6551C41.8051 73.3084 40.3051 74.8084 40.3051 76.6584H40.2951Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9151 77.9884C35.5851 77.9884 32.8951 80.6884 32.8951 84.0084H68.6152C68.6152 80.6784 65.9151 77.9884 62.5951 77.9884H38.9151Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1051 56.7384L24.7851 30.5484C25.0451 30.3684 25.2551 30.1184 25.3951 29.8184L45.4851 30.8284C45.3051 30.2884 45.2051 29.6984 45.2051 29.0984C45.2051 28.4984 45.3051 27.9084 45.4851 27.3684L25.3851 28.3784C25.1051 27.7684 24.4951 27.3384 23.7751 27.3384C22.8051 27.3384 22.0151 28.1284 22.0151 29.0984C22.0151 29.6984 22.3151 30.2284 22.7751 30.5484L12.4551 56.7384C12.4351 56.7884 12.4251 56.8284 12.4251 56.8884C12.4251 63.1484 17.5151 68.2384 23.7751 68.2384C30.0351 68.2384 35.1251 63.1484 35.1251 56.8884C35.1251 56.8384 35.1151 56.7884 35.0951 56.7384H35.1051ZM24.1751 56.4884V31.1884L34.1451 56.4884H24.1751ZM23.3751 56.4884H13.4051L23.3751 31.1884V56.4884Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6751 30.9884V31.0884C49.1951 31.6384 49.9351 31.9784 50.7451 31.9784C51.5551 31.9784 52.2952 31.6384 52.8251 31.0884V30.9884H52.9251C53.3651 30.4784 53.6351 29.8184 53.6351 29.0984C53.6351 28.3784 53.3651 27.7184 52.9251 27.2084H52.6451L52.6351 26.9184C52.1351 26.4784 51.4751 26.2184 50.7551 26.2184C50.0351 26.2184 49.3751 26.4784 48.8751 26.9184V27.1984L48.5851 27.2084C48.1451 27.7184 47.8751 28.3784 47.8751 29.0984C47.8751 29.8184 48.1451 30.4784 48.5851 30.9884H48.6851H48.6751Z",
    fill: "#9933CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1695",
    x: 0.0000118613,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1695",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1695"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1695",
    result: "effect3_innerShadow_4857_1695"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalServices);
export default __webpack_public_path__ + "static/media/LegalServices.5a6d12f7dbe9ae4fac6130e7065b7f67.svg";
export { ForwardRef as ReactComponent };